import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

/**
 * @hideMenu {导航不显示}
 * @hideChildMenu {隐藏子导航}
 * @accountMenu {标识个人中心侧边导航}
 */
const BaseLayout = () =>
  import(/* webpackChunkName: "layouts" */ '../layouts/BaseLayout');
const AccountLayout = () =>
  import(/* webpackChunkName: "layouts" */ '../layouts/AccountLayout');
const router = new Router({
  // mode: "history",
  routes: [
    {
      path: '/',
      redirect: '/home/index',
      hideMenu: true
    },
    {
      path: '/login',
      name: 'login',
      hideMenu: true,
      component: () =>
        import(/* webpackChunkName: "layouts" */ '../views/Login')
    },
    {
      path: '/register',
      name: 'register',
      hideMenu: true,
      component: () =>
        import(/* webpackChunkName: "layouts" */ '../views/Register')
    },
    {
      path: '/home',
      redirect: '/home/index',
      name: 'home',
      meta: {
        title: '首页'
      },
      component: BaseLayout,
      children: [
        {
          path: '/home/index',
          name: 'homeIndex',
          meta: {
            title: '首页'
          },
          component: () =>
            import(/* webpackChunkName: "home" */ '../views/Home/index')
        }
      ]
    },
    {
      path: '/auction',
      name: 'auction',
      meta: {
        title: '拍卖中心'
      },
      redirect: '/auction/index',
      component: BaseLayout,
      children: [
        {
          path: '/auction/index',
          name: 'auctionIndex',
          meta: {
            title: '拍卖中心'
          },
          component: () =>
            import(/* webpackChunkName: "auction" */ '../views/Auction/index')
        },
        {
          path: '/auction/detail',
          redirect: '/auction/detail/index',
          meta: {
            title: '拍卖详情'
          },
          component: { render: h => h('router-view') },
          children: [
            {
              path: '/auction/detail/index',
              name: 'auctionDetailIndex',
              component: () =>
                import(/* webpackChunkName: "auction" */ '../views/Auction/Detail/index')
            },
            {
              path: '/auction/detail/success',
              name: 'auctionDetailSuccess',
              meta: {
                title: '拍卖成功',
                authLogin: true
              },
              component: () =>
                import(/* webpackChunkName: "auction" */ '../views/Auction/Detail/Success')
            },
            {
              path: '/auction/detail/order',
              name: 'auctionDetailOrder',
              meta: {
                title: '订单详情',
                authLogin: true
              },
              component: () =>
                import(/* webpackChunkName: "auction" */ '../views/Auction/Detail/Order')
            }
          ]
        },
        {
          path: '/auction/view',
          name: 'auctionView',
          meta: {
            title: '拍卖查看'
          },
          component: () =>
            import(/* webpackChunkName: "auction" */ '../views/Auction/View')
        }
      ]
    },
    {
      path: '/shop',
      name: 'shop',
      meta: {
        title: '商品中心'
      },
      redirect: '/shop/index',
      component: BaseLayout,
      children: [
        {
          path: '/shop/index',
          name: 'shopIndex',
          meta: {
            title: '商品中心'
          },
          component: () =>
            import(/* webpackChunkName: "shop" */ '../views/Shop/index')
        },
        {
          path: '/shop/detail',
          redirect: '/shop/detail/index',
          meta: {
            title: '商品详情'
          },
          component: { render: h => h('router-view') },
          children: [
            {
              path: '/shop/detail/index',
              name: 'shopDetailIndex',
              component: () =>
                import(/* webpackChunkName: "shop" */ '../views/Shop/Detail/index')
            },
            {
              path: '/shop/detail/success',
              name: 'shopDetailSuccess',
              meta: {
                title: '添加购物车成功',
                authLogin: true
              },
              component: () =>
                import(/* webpackChunkName: "auction" */ '../views/Shop/Detail/success')
            }
          ]
        },
        {
          path: '/shop/detail/order',
          name: 'shopDetailOrder',
          meta: {
            title: '订单详情',
            authLogin: true
          },
          component: () =>
            import(/* webpackChunkName: "auction" */ '../views/Shop/Detail/Order')
        }
      ]
    },
    {
      path: '/knowledge',
      name: 'knowledge',
      meta: {
        title: '锦鲤知识'
      },
      redirect: '/knowledge/index',
      component: BaseLayout,
      children: [
        {
          path: '/knowledge/index',
          name: 'knowledgeIndex',
          meta: {
            title: '锦鲤知识'
          },
          component: () =>
            import(/* webpackChunkName: "knowledge" */ '../views/Knowledge/index')
        },
        {
          path: '/knowledge/detail/:id',
          name: 'knowledgeDetail',
          meta: {
            title: '知识详情'
          },
          component: () =>
            import(/* webpackChunkName: "knowledge" */ '../views/Knowledge/Detail')
        }
      ]
    },
    {
      path: '/news',
      name: 'news',
      meta: {
        title: '新闻资讯'
      },
      redirect: '/news/index',
      component: BaseLayout,
      children: [
        {
          path: '/news/index',
          name: 'newsIndex',
          meta: {
            title: '新闻资讯'
          },
          component: () =>
            import(/* webpackChunkName: "news" */ '../views/News/index')
        },
        {
          path: '/news/detail/:id',
          name: 'newsDetail',
          meta: {
            title: '资讯详情'
          },
          component: () =>
            import(/* webpackChunkName: "news" */ '../views/News/Detail')
        }
      ]
    },
    {
      path: '/case',
      name: 'case',
      meta: {
        title: '庭院范例'
      },
      redirect: '/case/index',
      component: BaseLayout,
      children: [
        {
          path: '/case/index',
          name: 'caseIndex',
          meta: {
            title: '庭院范例'
          },
          component: () =>
            import(/* webpackChunkName: "case" */ '../views/Case/index')
        }
      ]
    },
    {
      path: '/about',
      name: 'about',
      meta: {
        title: '关于我们'
      },
      redirect: '/about/index',
      component: BaseLayout,
      children: [
        {
          path: '/about/index',
          name: 'aboutIndex',
          meta: {
            title: '关于我们'
          },
          component: () =>
            import(/* webpackChunkName: "about" */ '../views/About/index')
        }
      ]
    },
    {
      path: '/account',
      name: 'account',
      meta: {
        title: '个人中心'
      },
      hideMenu: true,
      accountMenu: true,
      redirect: '/account/information/index',
      component: BaseLayout,
      children: [
        {
          path: '/account/information',
          name: 'accountInformation',
          meta: {
            title: '个人资料',
            icon: 'jl-icon-mingpian'
          },
          component: AccountLayout,
          redirect: '/account/information/index',
          children: [
            {
              path: '/account/information/index',
              name: 'informationIndex',
              meta: {
                title: '基本信息',
                authLogin: true
              },
              component: () =>
                import(/* webpackChunkName: "account" */ '../views/Account/information/index')
            },
            {
              path: '/account/information/resetPassword',
              name: 'informationResetPassword',
              meta: {
                title: '修改密码',
                authLogin: true
              },
              component: () =>
                import(/* webpackChunkName: "account" */ '../views/Account/information/ResetPassword')
            }
          ]
        },
        {
          path: '/account/auction',
          name: 'accountAuction',
          meta: {
            title: '我的拍卖',
            icon: 'jl-icon-paimai'
          },
          redirect: '/account/auction/auctionRecord',
          component: AccountLayout,
          children: [
            {
              path: '/account/auction/auctionRecord',
              name: 'accountAuctionRecord',
              meta: {
                title: '拍卖记录',
                authLogin: true
              },
              component: () =>
                import(/* webpackChunkName: "account" */ '../views/Account/auction/auctionRecord')
            },
            {
              path: '/account/auction/auctionDetail/:id',
              name: 'accountAuctionDetail',
              hideMenu: true,
              meta: {
                title: '拍卖详情',
                authLogin: true
              },
              component: () =>
                import(/* webpackChunkName: "account" */ '../views/Account/auction/auctionDetail')
            },
            {
              path: '/account/auction/refundRecord',
              name: 'accountRefundRecord',
              meta: {
                title: '退款记录',
                authLogin: true
              },
              component: () =>
                import(/* webpackChunkName: "account" */ '../views/Account/auction/refundRecord')
            }
          ]
        },
        {
          path: '/account/order',
          name: 'accountOrder',
          meta: {
            title: '我的订单',
            icon: 'jl-icon-dingdan'
          },
          redirect: '/order',
          component: AccountLayout,
          hideChildMenu: true,
          children: [
            {
              path: '/account/order/logistics/:id',
              name: 'accountOrderLogistics',
              meta: {
                title: '查看物流',
                authLogin: true
              },
              component: () =>
                import(/* webpackChunkName: "account" */ '../views/Account/order/logistics')
            },
            {
              path: '/account/order/detail/:id',
              name: 'accountOrderDetail',
              meta: {
                title: '订单详情',
                authLogin: true
              },
              component: () =>
                import(/* webpackChunkName: "account" */ '../views/Account/order/detail')
            }
          ]
        },
        {
          path: '/account/myCart',
          name: 'accountMyCart',
          meta: {
            title: '我的购物车',
            icon: 'jl-icon-gouwuche'
          },
          redirect: '/cart'
        },
        {
          path: '/account/message',
          name: 'accountMessage',
          meta: {
            title: '我的消息',
            icon: 'jl-icon-xiaoxi'
          },
          redirect: '/account/message/list',
          component: AccountLayout,
          hideChildMenu: true,
          children: [
            {
              path: '/account/message/list',
              name: 'accountMessageList',
              meta: {
                title: '消息列表',
                authLogin: true
              },
              component: () =>
                import(/* webpackChunkName: "account" */ '../views/Account/message/list')
            }
          ]
        },
        {
          path: '/account/loginOut',
          name: 'accountLoginOut',
          isLoginOut: true,
          meta: {
            title: '退出登录',
            icon: 'jl-icon-tuichu'
          }
        }
      ]
    },
    {
      path: '/order',
      name: 'order',
      redirect: '/order/list',
      component: BaseLayout,
      hideMenu: true,
      children: [
        {
          path: '/order/list',
          name: 'orderList',
          meta: {
            title: '订单列表',
            authLogin: true
          },
          component: () =>
            import(/* webpackChunkName: "order" */ '../views/Order/list')
        },
        {
          path: '/order/pay/:id',
          name: 'orderPay',
          hideMenu: true,
          meta: {
            title: '订单支付',
            authLogin: true
          },
          component: () =>
            import(/* webpackChunkName: "order" */ '../views/Order/pay')
        },
        {
          path: '/order/success',
          name: 'orderSuccess',
          hideMenu: true,
          meta: {
            title: '货到付款下单成功',
            authLogin: true
          },
          component: () =>
            import(/* webpackChunkName: "order" */ '../views/Order/success')
        }
      ]
    },
    {
      path: '/cart',
      name: 'cart',
      redirect: '/cart/list',
      component: BaseLayout,
      hideMenu: true,
      children: [
        {
          path: '/cart/list',
          name: 'cartList',
          meta: {
            title: '我的购物车',
            keepAlive: true,
            authLogin: true
          },
          component: () =>
            import(/* webpackChunkName: "cart" */ '../views/Cart/list')
        }
      ]
    },
    {
      path: '/404',
      name: '404',
      hideMenu: true,
      component: () => import(/* webpackChunkName: "layouts" */ '../views/404')
    },
    {
      path: '*',
      redirect: '/404',
      hideMenu: true
    }
  ]
});
// component: { render: h => h("router-view") },
export default router;
